"use client";

import { useSearchParams, useRouter } from "next/navigation";
import { BUILDER_FLOW_HTML } from "./builder-flow.html";
import { BUILDER_INSPECTOR_HTML } from "./builder-inspector.html";
import { BUILDER_INSPECTORS } from "./builder-inspectors";

/**
 * Strategy Builder (flow canvas) — EXACT reference render.
 * ?node=<id> opens the side inspector inside .ds-bldflow.
 */
export function BuilderFlowContent({ node: propNode }: { node?: string }) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const activeNode = searchParams?.get("node") || propNode;

  let html = BUILDER_FLOW_HTML;
  if (activeNode) {
    const needle = "drag to pan \u00b7 scroll to zoom \u00b7 click a node to edit it</span></div>";
    const inspector =
      activeNode === "instrument"
        ? BUILDER_INSPECTOR_HTML
        : BUILDER_INSPECTORS[activeNode] || BUILDER_INSPECTOR_HTML;
    html = html
      .replace('data-open="false"', 'data-open="true"')
      .replace(needle, needle + inspector);
  }

  const handleContainerClick = (e: React.MouseEvent<HTMLElement>) => {
    const el = e.target as HTMLElement;
    // closest() can fail on SVG sub-targets in some browsers — walk up manually as fallback
    let btn: HTMLElement | null = null;
    if (typeof el.closest === "function") {
      btn = el.closest<HTMLElement>("button[formaction], a[formaction], [data-href]");
    }
    if (!btn) {
      let p: HTMLElement | null = el;
      while (p && p !== e.currentTarget) {
        if (
          (p.tagName === "BUTTON" && p.hasAttribute("formaction")) ||
          (p.tagName === "A" && (p.hasAttribute("formaction") || p.hasAttribute("data-href"))) ||
          p.hasAttribute("data-href")
        ) {
          btn = p;
          break;
        }
        p = p.parentElement;
      }
    }
    if (btn) {
      const action = btn.getAttribute("formaction") || btn.getAttribute("data-href");
      if (action) {
        e.preventDefault();
        e.stopPropagation();
        router.push(action.startsWith("?") ? `/wealth/trading/builder/flow${action}` : action);
      }
    }
  };

  return (
    <div
      onClick={handleContainerClick}
      style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", minHeight: 0, flex: 1 }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
